import { HttpClient } from "@angular/common/http";
import { inject, Injectable, signal, WritableSignal } from "@angular/core";

import { SecureWalletDto, UnBlockWalletDto, Wallet } from "../models/wallet.model";
import { environment } from "@env/environment";
import { Transaction } from "@core/models";
import { map, Observable, tap } from "rxjs";
import { Tab } from "primeng/tabs";

@Injectable()
export class WalletService {
  private readonly http = inject(HttpClient)
  private readonly WALLET_KEY = 'onsite_wallet';

  wallet: WritableSignal<Wallet | null> = signal(null);
  rechargeHistory: WritableSignal<Transaction[] | null> = signal(null);
  purchaseHistory: WritableSignal<Transaction[] | null> = signal(null);

  rechargeAmount: WritableSignal<number | null> = signal(null);

  constructor() {
    this.loadWallet();
  }

  // loadWallet() {
  //   const wallet = localStorage.getItem(this.WALLET_KEY);
  //   if (wallet) {
  //     this.wallet.set(JSON.parse(wallet));
  //   }
  // }

  loadWallet(): Observable<Wallet> {
    return this.http.get(`${environment.apiURL}/wallets`).pipe(
      tap((response: any) => {
        this.wallet.set(response.data);
      }),
      map((response: any) => response.data)
    );
  }

  setWallet(wallet: Wallet) {
    this.wallet.set(wallet);
    localStorage.setItem(this.WALLET_KEY, JSON.stringify(wallet));
  }

  secureWallet(dto: SecureWalletDto) {
    this.http.post(`${environment.apiURL}/wallets/secure`, dto).subscribe(() => {
      this.wallet.update(wallet => {
        if (wallet) {
          return { ...wallet, block: true };
        }
        return wallet;
      });
    });
  }

  unBlockWallet(dto: UnBlockWalletDto) {
    return this.http.post(`${environment.apiURL}/wallets/block-unblock`, dto);
  }

  getWalletCreditReport() {
    return this.http.get(`${environment.apiURL}/wallets/report/credits`).pipe(
      tap((response: any) => {
        this.rechargeHistory.set(response.data as Transaction[]);
      })
    );
  }

  getWalletPaymentReport() {
    return this.http.get(`${environment.apiURL}/wallets/report/payments`).pipe(
      tap((response: any) => {
        this.purchaseHistory.set(response.data as Transaction[]);
      })
    );
  }
}
